import React from 'react';
import { RenderMarkdownWithLatex } from '../../utils/utils';

const SubfieldProgress = ({ subfield }) => {
    const { subfield_name, elo_threshold, is_unlocked, example_problem } = subfield;

    return (
        <div className={`p-3 rounded-lg border ${is_unlocked ? 'bg-white' : 'bg-gray-100 opacity-70'}`}>
            {/* === ZMIANA W TEJ LINII === */}
            <div className="flex justify-between items-center gap-x-3"> 
                <span className={`flex-1 font-semibold text-sm ${is_unlocked ? 'text-gray-800' : 'text-gray-500'}`}>
                    {subfield_name}
                </span>
                <span className={`flex-shrink-0 text-xs font-mono px-2 py-0.5 rounded-full ${is_unlocked ? 'bg-green-100 text-green-800' : 'bg-gray-200 text-gray-600'}`}>
                    ELO tematu: {elo_threshold || 10}
                </span>
            </div>
            {example_problem && (
                <div className="mt-2 pt-2 border-t border-gray-200 text-xs text-gray-600">
                    <p className="font-semibold mb-1">Przykładowe zadanie:</p>
                    <div className="p-2 bg-gray-50 rounded">
                        <RenderMarkdownWithLatex text={example_problem.question} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default SubfieldProgress;